import Vue from 'vue'
import Vuex from 'vuex'
import SwaggerClient from 'swagger-client'
import { inspect } from 'util'
import { reject } from 'q';
import mixin from './mixin'
import * as subSystem from './utils/subSystem';

Vue.use(Vuex)
Vue.mixin(mixin)

const LOGIN = 'LOGIN'
const SSO_LOGIN = 'SSO_LOGIN'
const LOGIN_WITH_TOKEN = 'LOGIN_WITH_TOKEN'
const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
const LOGOUT = 'LOGOUT'
// 最新バージョン情報
const VERSION = '20261016'
// url
var url = location.href;
console.log(url)
var ENV
if (url.indexOf('https://sr-gu.com/') != -1) {
  ENV = "production"
} else if (url.indexOf('https://qa.sr-gu.com/') != -1 || url.indexOf('https://qa.sr-gu.com:80/') != -1) {
  ENV = "qa"
} else if (url.indexOf('https://qa.sr-gu.com:') != -1) {
  ENV = "qaMock"
} else {
  ENV = "development"
}

export default new Vuex.Store({
  state: {
    isLoggedIn: !!sessionStorage.getItem('userInfo'),
    version: VERSION,
    env: ENV,
    subSystem: sessionStorage.getItem('subSystem') ?
      JSON.parse(sessionStorage.getItem('subSystem')) :
      subSystem.SUB_SYSTEMS.breath,
    isSSOLogin:process.env.IS_SSO_LOGIN,
    ssoLogoutUrl: process.env.SSO_LOGOUT,
    ssoLogin:process.env.SSO_LOGIN,
  },
  mutations: {
    [LOGIN](state) {
      state.pending = true
    },
    [SSO_LOGIN](state) {
      state.pending = true
    },
    [LOGIN_WITH_TOKEN](state) {
      state.pending = true
    },
    [LOGIN_SUCCESS](state) {
      state.isLoggedIn = true
      state.pending = false
    },
    [LOGOUT](state) {
      state.isLoggedIn = false
    },
    subSystem(state) {
      state.subSystem = JSON.parse(sessionStorage.getItem('subSystem'));
      return;
    },
  },
  actions: {
    login({ commit }, creds) {
      commit(LOGIN) // show spinner
      return new Promise(resolve => {
        new SwaggerClient({
          url: '/api-docs',
          requestInterceptor: req => {
            if (req.body && !req.headers['Content-Type']) {
              req.headers['Content-Type'] = 'application/json'
            }
          }
        }).then(client => {
          client.apis.auth.loginPOST({
            body: {
              mail: creds.mail,
              password: creds.password,
              otptoken: creds.otptoken,
              accessType: creds.accessType,
              version: VERSION,
              ssologin: creds.isSSOLogin
            }
          }).then(result => {
            console.log(result)
            sessionStorage.setItem('userInfo', JSON.stringify(result.obj))
            var lastLoginDate = JSON.parse(sessionStorage.getItem('userInfo')).preLoginedTimestamp
            if (lastLoginDate != "Invalid Date") {
              sessionStorage.setItem('lastLoginDate', lastLoginDate)
            } else {
              sessionStorage.setItem('lastLoginDate', "")
            }
            if (JSON.parse(sessionStorage.getItem('userInfo')).message.length > 0) {
              alert(JSON.parse(sessionStorage.getItem('userInfo')).message)
            }
            commit(LOGIN_SUCCESS)
            resolve(0)
          }).catch(error => {
            if (error != null && (error.status === 400 || error.status === 401 || error.status === 500)) {
              // サーバから返されたメッセージをダイアログ表示
              console.log(error.response.body.message)
              this._vm.showErrorMessage(error.response.body.message)
              resolve(1)
              // reject()
            } else {
              // "予期しないエラーが発生しました。"でダイアログを表示
              alert("予期しないエラーが発生しました。")
            }
            resolve(1)
            // reject()
          })
        }).catch(error => {
          // "予期しないエラーが発生しました。"でダイアログを表示
          console.log(error)
          alert("予期しないエラーが発生しました。")
          resolve(1)
          // reject()
        })
      })
    },
    ssoLogin({ commit }, creds) {
      return new Promise(resolve => {
        new SwaggerClient({
          url: '/api-docs',
          requestInterceptor: req => {
            if (req.body && !req.headers['Content-Type']) {
              req.headers['Content-Type'] = 'application/json'
            }
          }
        }).then(client => {
          client.apis.auth.loginPOST({
            body: {
              mail: creds.mail,
              password: creds.password,
              otptoken: creds.otptoken,
              accessType: creds.accessType,
              version: VERSION,
              ssologin: creds.isSSOLogin
            }
          }).then(result => {
            window.location.href = process.env.SSO_REQ;
            
            resolve(0)
          }).catch(error => {
            if (error != null && (error.status === 400 || error.status === 401 || error.status === 500)) {
              // サーバから返されたメッセージをダイアログ表示
              console.log(error.response.body.message)
              this._vm.showErrorMessage(error.response.body.message)
              resolve(1)
            } else {
              // "予期しないエラーが発生しました。"でダイアログを表示
              alert("予期しないエラーが発生しました。")
            }
            resolve(1)
          })
        }).catch(error => {
          // "予期しないエラーが発生しました。"でダイアログを表示
          console.log(error)
          alert("予期しないエラーが発生しました。")
          resolve(1)
        })
      })
    },
    ssoLoginInfo({ commit }, creds) {
      return new Promise(resolve => {
        commit(LOGIN) // show spinner
        fetch(process.env.SSO_INFO)
          .then(res => res.json())
          .then(data => {
          new SwaggerClient({
            url: '/api-docs',
            requestInterceptor: req => {
              if (req.body && !req.headers['Content-Type']) {
                req.headers['Content-Type'] = 'application/json'
              }
            }
          }).then(client => {
            client.apis.auth.loginPOST({
              body: {
                mail: data.email,
                otptoken: creds.otptoken || "",
                accessType: creds.accessType || "",
                version: VERSION,
                ssologin: creds.isSSOLogin
              }
            }).then(result => {
              console.log(result)
              sessionStorage.setItem('userInfo', JSON.stringify(result.obj))
              var lastLoginDate = JSON.parse(sessionStorage.getItem('userInfo')).preLoginedTimestamp
              if (lastLoginDate != "Invalid Date") {
                sessionStorage.setItem('lastLoginDate', lastLoginDate)
              } else {
                sessionStorage.setItem('lastLoginDate', "")
              }
              if (JSON.parse(sessionStorage.getItem('userInfo')).message.length > 0) {
                alert(JSON.parse(sessionStorage.getItem('userInfo')).message)
              }
              commit(LOGIN_SUCCESS)
              resolve(0)
            }).catch(async error => {
              if (error != null && (error.status === 400 || error.status === 401 || error.status === 500)) {
                // サーバから返されたメッセージをダイアログ表示
                console.log(error.response.body.message)
                await new Promise(resolve => {
                  this._vm.$dialog.confirm({
                    title: '　',
                    message: error.response.body.message,
                    canCancel: true,
                    confirmText: 'OK',
                    cancelText: 'ログアウト',
                    onConfirm: () => {
                      resolve();
                    },
                    onCancel: () => {
                      // ダイアログの「ログアウト」後にログアウト
                      window.location.href = process.env.SSO_LOGOUT
                    }
                  });
                });
              } else {
                // "予期しないエラーが発生しました。"でダイアログを表示
                alert("予期しないエラーが発生しました。")
              }
              // reject()
            })
          }).catch(error => {
            // "予期しないエラーが発生しました。"でダイアログを表示
            console.log(error)
            alert("予期しないエラーが発生しました。")
            resolve(1)
            // reject()
          })
        })
      })
    },
    loginWithToken({ commit }, creds) {
      commit(LOGIN_WITH_TOKEN) // show spinner
      return new Promise(resolve => {
        new SwaggerClient({
          url: '/api-docs',
          requestInterceptor: req => {
            if ((typeof req.body === "undefined" || req.body) && !req.headers['Content-Type']) {
              req.headers['Content-Type'] = 'application/json'
              req.headers['Authorization'] = creds.token
            }
          }
        }).then(client => {
          client.apis.auth.loginWithTokenPOST({
            body: {}
          }).then(result => {
            console.log(result)
            sessionStorage.setItem('userInfo', JSON.stringify(result.obj))
            var lastLoginDate = JSON.parse(sessionStorage.getItem('userInfo')).preLoginedTimestamp
            if (lastLoginDate != "Invalid Date") {
              sessionStorage.setItem('lastLoginDate', lastLoginDate)
            } else {
              sessionStorage.setItem('lastLoginDate', "")
            }
            if (JSON.parse(sessionStorage.getItem('userInfo')).message.length > 0) {
              alert(JSON.parse(sessionStorage.getItem('userInfo')).message)
            }
            commit(LOGIN_SUCCESS)
            resolve()
          }).catch(error => {
            reject()
          })
        }).catch(error => {
          reject()
        })
      })
    },
    logout({ commit }, creds) {
      return new Promise(resolve => {
        new SwaggerClient({
          url: '/api-docs',
          requestInterceptor: req => {
            if (req.body && !req.headers['Content-Type']) {
              req.headers['Content-Type'] = 'application/json'
              req.headers['Authorization'] = JSON.parse(sessionStorage.getItem('userInfo')).token
            }
          }
        }).then(client => {
          client.apis.auth.logoutPOST({
            body: {
              ssoToken: creds.token
            }
          }).then(result => {
            console.log(result)
            sessionStorage.removeItem('userInfo')
            sessionStorage.removeItem('officeMaster')
            sessionStorage.removeItem('referenceEnableOffice')
            sessionStorage.removeItem('hardwareMaster')
            commit(LOGOUT)
            resolve()
          }).catch(error => {
            console.log(error)
            // エラーが発生した場合もローカルストレージは破棄
            sessionStorage.removeItem('userInfo')
            sessionStorage.removeItem('officeMaster')
            sessionStorage.removeItem('hardwareMaster')
            commit(LOGOUT)
            resolve()
          })
        }).catch(error => {
          console.log(error)
          // エラーが発生した場合もローカルストレージは破棄
          sessionStorage.removeItem('userInfo')
          sessionStorage.removeItem('officeMaster')
          sessionStorage.removeItem('referenceEnableOffice')
          sessionStorage.removeItem('hardwareMaster')
          commit(LOGOUT)
          resolve()
        })
      })
    },
    pwdInit({ commit }, creds) {
      return new Promise(resolve => {
        new SwaggerClient({
          url: '/api-docs',
          requestInterceptor: req => {
            if (req.body && !req.headers['Content-Type']) {
              req.headers['Content-Type'] = 'application/json'
            }
          }
        }).then(client => {
          client.apis.auth.passwordinitPOST({
            body: {
              mail: creds.mail,
              otptoken: creds.otptoken
            }
          }).then(result => {
            console.log(result)
            creds.showDialog(result.obj['message'])
            resolve()
          }).catch(error => {
            if (error != null && (error.status === 400 || error.status === 401 || error.status === 500)) {
              // サーバから返されたメッセージをダイアログ表示
              console.log(error.response.body.message)
              alert(error.response.body.message)
            } else {
              // "予期しないエラーが発生しました。"でダイアログを表示
              alert("予期しないエラーが発生しました。")
            }
            reject()
          })
        }).catch(error => {
          // "予期しないエラーが発生しました。"でダイアログを表示
          alert("予期しないエラーが発生しました。")
          console.log(error)
          reject()
        })
      })
    },
    passwordForceChange({ commit }, creds) {
      return new Promise(resolve => {
        new SwaggerClient({
          url: '/api-docs',
          requestInterceptor: req => {
            if (req.body && !req.headers['Content-Type']) {
              req.headers['Content-Type'] = 'application/json'
              req.headers['Authorization'] = JSON.parse(sessionStorage.getItem('userInfo')).token
            }
          }
        }).then(client => {
          client.apis.auth.passwordresetPOST({
            body: {
              currentpassword: creds.currentpassword,
              newpassword: creds.newpassword
            }
          }).then(result => {
            console.log(result)
            alert(result.obj['message'])
            resolve()
          }).catch(error => {
            if (error != null && (error.status === 400 || error.status === 401 || error.status === 500)) {
              // サーバから返されたメッセージをダイアログ表示
              console.log(error.response.body.message)
              alert(error.response.body.message)
            } else {
              // "予期しないエラーが発生しました。"でダイアログを表示
              alert("予期しないエラーが発生しました。")
            }
            reject()
          })
        }).catch(error => {
          // "予期しないエラーが発生しました。"でダイアログを表示
          console.log(error)
          alert("予期しないエラーが発生しました。")
          reject()
        })
      })
    },
    getBranchMaster({ }) {
      const userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
      return new Promise(resolve => {
        new SwaggerClient({
          url: '/api-docs',
          requestInterceptor: req => {
            req.headers['Authorization'] = userInfo.token
          }
        }).then(client => {
          client.apis.apiMaster.getBranchesGET(
          ).then(result => {
            sessionStorage.setItem('branchMaster', JSON.stringify(result.obj));
            resolve()
          }).catch(error => {
            console.log(error)
            resolve()
          })
        }).catch(error => {
          console.log(error)
          resolve()
        })
      })
    },
    getOfficeMaster({ }) {
      var userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
      return new Promise(resolve => {
        new SwaggerClient({
          url: '/api-docs',
          requestInterceptor: req => {
            if (req.body && !req.headers['Content-Type']) {
              req.headers['Content-Type'] = 'application/json'
              req.headers['Authorization'] = userInfo.token
            }
          }
        }).then(client => {
          client.apis.apiMaster.getOfficeListPOST({
            body: {}
          }).then(result => {
            console.log(result)
            var officeMaster = []
            var referenceEnableOffice = []
            for (var i = 0; i < result.obj.length; i++) {
              var office = {
                "officeCode": result.obj[i].officeCode,
                "officeName": result.obj[i].officeName,
                "phoneNumber": result.obj[i].phoneNumber,
              }
              officeMaster.push(office)
              if (userInfo.roleId === 1
                || userInfo.roleId === 2
                || result.obj[i].officeCode === userInfo.officeCode
                || userInfo.referenceOfficeCodes.indexOf(result.obj[i].officeCode) >= 0
              ) {
                referenceEnableOffice.push(office)
              }
            }
            sessionStorage.setItem('officeMaster', JSON.stringify(officeMaster))
            sessionStorage.setItem('referenceEnableOffice', JSON.stringify(referenceEnableOffice))
            resolve()
          }).catch(error => {
            console.log(error)
            resolve()
          })
        }).catch(error => {
          console.log(error)
          resolve()
        })
      })
    },
    getPositionMaster({ }) {
      var userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
      return new Promise(resolve => {
        new SwaggerClient({
          url: '/api-docs',
          requestInterceptor: req => {
            req.headers['Content-Type'] = 'application/json'
            req.headers['Authorization'] = userInfo.token
          }
        }).then(client => {
          client.apis.apiMaster.getPositionListPOST({
          }).then(result => {
            console.log(result)
            var positionMaster = []
            for (var i = 0; i < result.obj.length; i++) {
              var position = {
                "positionCode": result.obj[i].positionCode,
                "positionName": result.obj[i].positionName
              }
              positionMaster.push(position)
            }
            sessionStorage.setItem('positionMaster', JSON.stringify(positionMaster))
            resolve()
          }).catch(error => {
            console.log(error)
            resolve()
          })
        }).catch(error => {
          console.log(error)
          resolve()
        })
      })
    },
    getInspectionHardwareMaster({ }) {
      var userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
      return new Promise(resolve => {
        new SwaggerClient({
          url: '/api-docs',
          requestInterceptor: req => {
            req.headers['Content-Type'] = 'application/json'
            req.headers['Authorization'] = userInfo.token
          }
        }).then(client => {
          client.apis.apiMaster.getInspectionHardwareListPOST({
          }).then(result => {
            console.log(result)
            let Hardwares = []
            for (var i = 0; i < result.obj.length; i++) {
              let hardware = {
                "itemCode": result.obj[i].itemCode,
                "reportFormatType": result.obj[i].reportFormatType
              }
              Hardwares.push(hardware)
            }
            sessionStorage.setItem('hardwareMaster', JSON.stringify(Hardwares))
            resolve()
          }).catch(error => {
            console.log(error)
            resolve()
          })
        }).catch(error => {
          console.log(error)
          resolve()
        })
      })
    },

    changeSubSystem({ commit }, subSystem) {
      sessionStorage.setItem('subSystem', JSON.stringify(subSystem));
      commit("subSystem");
    },
  }
})


// WEBPACK FOOTER //
// ./src/store.js